import React, { useState, useEffect } from 'react';
import { getCookie } from '../utils';

export default function PaymentModal({ enrollmentId, enrollments, students, batches, closeModal }) {
  const [payments, setPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Safely find associated local data
  const enroll = enrollments.find(e => e.id === enrollmentId);
  const student = students.find(s => s.id === enroll?.studentId);
  const batch = batches.find(b => b.id === enroll?.batchId);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const token = getCookie('tsa_token');
        const res = await fetch('https://tsaapis.operate.live/api/payments', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token || ''
          },
          credentials: 'include'
        });

        if (res.ok) {
          const data = await res.json();
          
          // Filter payments matching this specific enrollment
          // Handling both string IDs and populated Mongoose object IDs
          const enrollmentPayments = data.filter(p => 
            p.EnrolmentId === enrollmentId || 
            (p.EnrolmentId && p.EnrolmentId._id === enrollmentId)
          );
          
          // Sort by newest first
          enrollmentPayments.sort((a, b) => new Date(b.PaidDT) - new Date(a.PaidDT));
          
          setPayments(enrollmentPayments);
        }
      } catch (err) {
        console.error("API Error fetching payments:", err);
      } finally {
        setIsLoading(false);
      }
    };

    if (enrollmentId) {
      fetchPayments();
    }
  }, [enrollmentId]);

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-modal" onClick={closeModal}>&times;</button>
        <h2>{student?.name || 'Student'}'s Payment Info</h2>
        
        {isLoading ? (
           <div style={{ textAlign: 'center', padding: '30px' }}>
             <i className="fas fa-spinner fa-spin fa-2x" style={{ color: 'var(--accent-gold)', marginBottom: '10px' }}></i>
             <p style={{ color: 'var(--text-gray)' }}>Loading payment history...</p>
           </div>
        ) : (
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Date Paid</th>
                  <th>Mode</th>
                  <th>Ref</th>
                  <th>Amount Paid</th>
                </tr>
              </thead>
              <tbody>
                {payments.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center', padding: '20px', color: 'var(--text-gray)' }}>
                      No payment records found for this enrollment.
                    </td>
                  </tr>
                ) : (
                  payments.map((payment) => (
                    <tr key={payment._id || payment.id}>
                      <td>{new Date(payment.PaidDT).toLocaleDateString()}</td>
                      <td><span className="badge">{payment.Mode}</span></td>
                      <td>{payment.TransactionRef || 'N/A'}</td>
                      <td>
                        <strong style={{color:'var(--accent-gold)'}}>₹{payment.PaidAmount}</strong><br/>
                        <small style={{ color: '#64748b' }}>/ ₹{batch?.fees} Total</small>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}